import React, { FC } from "react";

import { Modal, Text } from "@epignosis_llc/gnosis";

import { externalModalBody } from "@components/ReusableModals/styles";

import { useApplyTranslations } from "@hooks";
import { useConfigurationStore } from "@stores";

import { images } from "@constants/assets";

import ExternalFooterButtons from "@components/ReusableModals/components/ExternalFooterButtons";

export type ExternalApprovalModalProps = {
  isOpen: boolean;
  courseName: string;
  courseImage?: string;
  onClose: () => void;
};

const ExternalApprovalModal: FC<ExternalApprovalModalProps> = ({
  isOpen,
  courseName,
  courseImage,
  onClose,
}) => {
  const { t } = useApplyTranslations();
  const { domainSettings } = useConfigurationStore();
  const isSignUpEnabled = Boolean(domainSettings?.signup.enabled);

  const translationText = isSignUpEnabled
    ? t("courseCatalog.youSelectedToGetCourseWithApprovalSignUp", { name: courseName })
    : t("courseCatalog.youSelectedToGetCourseWithApproval", { name: courseName });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>{courseName}</Modal.Header>
      <Modal.Body css={externalModalBody}>
        <img
          src={courseImage ?? images.cover}
          alt={`${courseName} cover image.`}
          className="course-img"
        />

        <Text
          fontSize="sm"
          dangerouslySetInnerHTML={{
            __html: translationText,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <ExternalFooterButtons onClose={onClose} actionType="payment" />
      </Modal.Footer>
    </Modal>
  );
};

export default ExternalApprovalModal;
